import React from 'react'
import styles from './Form.module.css'
import classNames from 'classnames/bind'

const cx = classNames.bind(styles)

const Form = props => (
  <div className={`${props.className} form-el ${cx({ base: true, isDisabled: props.disabled })}`}>
    {props.title &&
      <h3>{props.title}</h3>
    }
    {props.children}
  </div>
)

const FormRow = props => (
  <div className={`${props.className} form-row-el ${cx({ row: true, isAlignedToRight: props.right, isSpacedBetween: props.between })}`}>
    {props.title &&
      <h4>{props.title}</h4>
    }
    {props.children}
  </div>
)

const FormOption = props => (
  <div className={`form-option-el ${styles.option}`}>
    {props.children}
  </div>
)

export default Form
export { FormRow, FormOption }
